import { render } from "./ProsesEvaluator.vue?vue&type=template&id=1010d796"
import script from "./ProsesEvaluator.vue?vue&type=script&lang=js"
export * from "./ProsesEvaluator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__